import React from 'react'
import styled from '@emotion/styled'
import { DEFAULT_THEME_COLORS } from 'css/theme'

interface FormSectionDividerProps {
  className?: string
  margin?: string
}

const DividerContainer = styled.div<{ margin?: string }>`
  margin: ${(props) => props.margin || '24px 0'};
`

const DividerLine = styled.hr`
  border: none;
  height: 1px;
  background-color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-80']};
  margin: 0;
  width: 100%;
`

const FormSectionDivider: React.FC<FormSectionDividerProps> = ({ className, margin }) => {
  return (
    <DividerContainer className={className} margin={margin}>
      <DividerLine />
    </DividerContainer>
  )
}

export default FormSectionDivider
